import { Component, ElementRef, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { merge } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonService } from 'src/app/common.service';

@Component({
  selector: 'app-verify-otp',
  templateUrl: './verify-otp.component.html',
  styleUrl: './verify-otp.component.css'
})
export class VerifyOtpComponent {
  verifyotpForm: UntypedFormGroup;
  submitable = false;
  error = '';
  code = '';
  returnUrl: string;
  errorMessage: any;
  load: boolean = false;
  processing: boolean = false;
  mfa: boolean = false;
  @ViewChild('otp1') otp1!: ElementRef;
  @ViewChild('otp2') otp2!: ElementRef;
  @ViewChild('otp3') otp3!: ElementRef;
  @ViewChild('otp4') otp4!: ElementRef;
  @ViewChild('otp5') otp5!: ElementRef;
  @ViewChild('otp6') otp6!: ElementRef;
  constructor(private router: Router, private route: ActivatedRoute, private formBuilder: UntypedFormBuilder, private dataservice: CommonService, private _snackBar: MatSnackBar, elementref: ElementRef) {
    this.code = this.route.snapshot.paramMap.get('code');
    this.mfa = this.route.snapshot.paramMap.get('mfa') !='0'?true:false;
    this.verifyotpForm = this.formBuilder.group({
      otp1: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]],
      otp2: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]],
      otp3: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]],
      otp4: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]],
      otp5: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]],
      otp6: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]]
    });
    this.errorMessage = { otp1: '', otp2: '', otp3: '', otp4: '', otp5: '', otp6: '' };
    merge(this.frmCtrl.otp1.statusChanges, this.frmCtrl.otp2.statusChanges, this.frmCtrl.otp3.statusChanges, this.frmCtrl.otp4.statusChanges, this.frmCtrl.otp5.statusChanges, this.frmCtrl.otp6.statusChanges)
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.updateErrorMessage());
    this.load = true;
  }
  get frmCtrl() {
    return this.verifyotpForm.controls;
  }
  moveToNext(event: any, nextInput: HTMLInputElement | null, prevInput: HTMLInputElement | null) {
    const input = event.target as HTMLInputElement;
    
    // Move focus to the next input if a digit is entered
    if (input.value.length === 1 && nextInput) {
      nextInput.focus();
    } else if (input.value.length === 0 && prevInput) {
      prevInput.focus();
    }else{
      if (!this.verifyotpForm.invalid) {
        this.onSubmit();
      }
    }
  }
  resendOtp() {
    
      this.processing = true;
      const data = {
        code: this.code
      };
      this.dataservice.sendPostRequest('/api/resend-otp', data).pipe(
        map((res: Response) => (JSON.stringify(res))))
        .subscribe(
          (response) => {
            this.processing = false;
            this.verifyotpForm.reset();
            this.otp1.nativeElement.focus();
            this.errorMessage = { otp1: '', otp2: '', otp3: '', otp4: '', otp5: '', otp6: '' };
          },
          (error) => {
            this.processing = false;
            if (error.status === 401) {
              this.error = error.error.error_message;
              // this.openSnackBar(error.error.error_message,'Dismiss');
            } else {
              this.error = error.error.error_message??error.error.error;
              // this.openSnackBar(error.error.error_message,'Dismiss');
            }
            this.verifyotpForm.reset();
            this.otp1.nativeElement.focus();
            this.errorMessage = { otp1: '', otp2: '', otp3: '', otp4: '', otp5: '', otp6: '' };
            this.frmCtrl.otp6.reset();
            console.log(error);
          });
  }
  onSubmit() {
    // stop here if form is invalid
    if (this.verifyotpForm.invalid) {
      return;
    } else {
      this.processing = true;
      const data = {
        code: this.code,
        otp: this.frmCtrl.otp1.value + this.frmCtrl.otp2.value + this.frmCtrl.otp3.value + this.frmCtrl.otp4.value + this.frmCtrl.otp5.value + this.frmCtrl.otp6.value
      };
      this.dataservice.sendPostRequest('/api/verify-otp', data).pipe(
        map((res: Response) => (JSON.stringify(res))))
        .subscribe(
          (response) => {
            this.processing = false;
            const result = JSON.parse(response);
            console.log(result);
            if(this.mfa){
              localStorage.setItem('currentUser', JSON.stringify(result.access_token));
              localStorage.setItem('userName', result.user.name);
              this.router.navigate(['panel/campaigns']);
            }else{
              this.router.navigate(['reset-password/' + result.code]);
            }
          },
          (error) => {
            this.processing = false;
            if (error.status === 401) {
              this.error = error.error.error_message;
              // this.openSnackBar(error.error.error_message,'Dismiss');
            } else {
              this.error = error.error.error_message??error.error.error;
              // this.openSnackBar(error.error.error_message,'Dismiss');
            }
            this.verifyotpForm.reset();
            this.otp1.nativeElement.focus();
            this.errorMessage = { otp1: '', otp2: '', otp3: '', otp4: '', otp5: '', otp6: '' };
            this.frmCtrl.otp6.reset();
            console.log(error);
          });
    }
  }

  updateErrorMessage() {
    this.submitable = true;

    if (this.frmCtrl.otp1.hasError('required')) {
      this.errorMessage.otp1 = 'OTP is required';
      this.submitable = false;
    } else if (this.frmCtrl.otp1 && this.frmCtrl.otp1.hasError('minlength')) {
      this.errorMessage.otp1 = 'Invalid OTP';
      this.submitable = false;
    } else if (this.frmCtrl.otp1 && this.frmCtrl.otp1.hasError('maxlength')) {
      this.errorMessage.otp1 = 'Invalid OTP';
      this.submitable = false;
    }
    if (this.frmCtrl.otp2.hasError('required')) {
      this.errorMessage.otp2 = 'OTP is required';
      this.submitable = false;
    } else if (this.frmCtrl.otp2 && this.frmCtrl.otp2.hasError('minlength')) {
      this.errorMessage.otp2 = 'Invalid OTP';
      this.submitable = false;
    } else if (this.frmCtrl.otp2 && this.frmCtrl.otp2.hasError('maxlength')) {
      this.errorMessage.otp2 = 'Invalid OTP';
      this.submitable = false;
    }
    if (this.frmCtrl.otp3.hasError('required')) {
      this.errorMessage.otp3 = 'OTP is required';
      this.submitable = false;
    } else if (this.frmCtrl.otp3 && this.frmCtrl.otp3.hasError('minlength')) {
      this.errorMessage.otp3 = 'Invalid OTP';
      this.submitable = false;
    } else if (this.frmCtrl.otp3 && this.frmCtrl.otp3.hasError('maxlength')) {
      this.errorMessage.otp3 = 'Invalid OTP';
      this.submitable = false;
    }
    if (this.frmCtrl.otp4.hasError('required')) {
      this.errorMessage.otp4 = 'OTP is required';
      this.submitable = false;
    } else if (this.frmCtrl.otp4 && this.frmCtrl.otp4.hasError('minlength')) {
      this.errorMessage.otp4 = 'Invalid OTP';
      this.submitable = false;
    } else if (this.frmCtrl.otp4 && this.frmCtrl.otp4.hasError('maxlength')) {
      this.errorMessage.otp4 = 'Invalid OTP';
      this.submitable = false;
    }
    if (this.frmCtrl.otp5.hasError('required')) {
      this.errorMessage.otp5 = 'OTP is required';
      this.submitable = false;
    } else if (this.frmCtrl.otp5 && this.frmCtrl.otp5.hasError('minlength')) {
      this.errorMessage.otp5 = 'Invalid OTP';
      this.submitable = false;
    } else if (this.frmCtrl.otp5 && this.frmCtrl.otp5.hasError('maxlength')) {
      this.errorMessage.otp5 = 'Invalid OTP';
      this.submitable = false;
    }
    if (this.frmCtrl.otp6.hasError('required')) {
      this.errorMessage.otp6 = 'OTP is required';
      this.submitable = false;
    } else if (this.frmCtrl.otp6 && this.frmCtrl.otp6.hasError('minlength')) {
      this.errorMessage.otp6 = 'Invalid OTP';
      this.submitable = false;
    } else if (this.frmCtrl.otp6 && this.frmCtrl.otp6.hasError('maxlength')) {
      this.errorMessage.otp6 = 'Invalid OTP';
      this.submitable = false;
    }
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action);
  }
}
